export const INTRO_SEEN =
  typeof sessionStorage !== "undefined" && sessionStorage.getItem("ksr-intro-seen");

export const REVEAL_DELAY = INTRO_SEEN ? 0 : 1.05;
